module.exports = __webpack_public_path__ + "static/media/manually-create-sections.3d14f606.png";